module.exports = __webpack_public_path__ + "img/icon-white-53.facf0351.svg";